export default function AileronCta({
  title = 'Need a systems and automation partner?',
  description = 'Bring your workflows, operations, or software idea to Aileron Systems for practical implementation support.',
}) {
  return (
    <section className="mx-auto max-w-7xl px-6 py-8">
      <div className="rounded-2xl border border-gray-200 bg-white p-6 sm:p-8">
        <h3 className="text-2xl font-semibold text-gray-900">{title}</h3>
        <p className="mt-2 text-gray-600">{description}</p>

        <div className="mt-5 flex flex-wrap gap-3">
          <a
            href="/contact"
            className="rounded-md bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-indigo-500"
          >
            Book a consultation
          </a>
          <a
            href="https://aileronsys.com"
            target="_blank"
            rel="noreferrer"
            className="rounded-md border border-gray-300 px-4 py-2.5 text-sm font-semibold text-gray-800 hover:bg-gray-50"
          >
            Explore Aileron Systems
          </a>
        </div>
      </div>
    </section>
  );
}
